/**
 * Call Tracking sidebar configuration
 */
export default {
  pathPrefix: '',
  items: [
    {
      label: 'Reports',
      href: '/reports',
      icon: 'fa-light fa-file-chart-column',
      activePath: 'reports'
    },
    {
      label: 'Report Configurations',
      href: '/reports/configurations',
      icon: 'fa-light fa-file-chart-column',
      activePath: 'report_configurations'
    },
    {
      label: 'Audits',
      href: '/audit_reports',
      icon: 'fa-light fa-file-chart-pie',
      activePath: 'audit_reports'
    },
    {
      label: 'Audit Configurations',
      href: '/audit_report_configurations',
      icon: 'fa-light fa-file-chart-pie',
      activePath: 'audit_report_configurations'
    }
  ]
}
